<template>
    <div class="text-center">

        <v-card class="security v-dialog-logout">
            <v-card-title>
                <span class="dialog-close en-close">
                    <v-icon @click="close">
                        {{ icons.mdiClose }}
                    </v-icon>
                </span>
            </v-card-title>
            <v-card-text class="pa-7 text-center"
                         style="position: relative;">
                <div>
                    <img style="height: 100px;"
                         src="@/assets/images/2025/trusteddevices.png"
                         alt="" />
                </div>
                <!-- <div style="position: absolute; right: 0;top: 0;">
                    <img src="@/assets/images/activatecard/activatecall.png"
                         alt="" />
                </div> -->
                <div class="font-weight-semibold text-color-black mx-1 mt-2"
                     style="font-size: 18px;">
                    {{ $t('This device is not registered') }}
                </div>

                <p class="text-color-black mt-5 mx-11"
                   style="font-size: 12px">
                    {{ $t(`This device is not registered as a trusted device. Do you want to add it?`) }}
                </p>

                <v-row class="mx-6 mt-4">
                    <v-col lg="12">
                        <v-btn block
                               color="primary"
                               type="submit"
                               @click="trustDevice()"
                               large>
                            {{ $t('Trust this device') }}
                        </v-btn>
                    </v-col>
                    <v-col lg="12">
                        <v-btn block
                               type="submit"
                               style="border: 1px solid #016fd0;"
                               @click="close"
                               large>
                            {{ $t('No') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

    </div>
</template>

<script>
import
{
    mdiClose
} from '@mdi/js'
import store from '@/store';

export default {
    props: {
        calldialog: {
            default: false,
            type: Boolean
        }
    },
    data: () => ({
        icons: {
            mdiClose
        },
        switchOn: [],
        isSusByUser: 'show',
        isNotSusByUser: 'hide',
        selectedLanguage: 'en',
        showTimer: false,
        time: 100,
        timerId: null,
        interval: {},
        value: 90,
    }),
    created()
    {
        // clearInterval(this.interval);
        console.log('ssssss');

        this.value = 90;
        store.subscribe((mutation) =>
        {
            if (mutation.type === 'accounts/SET_LANGUAGE')
            {
                this.selectedLanguage = mutation.payload;
            }
        });
    },
    mounted()
    {
        // clearInterval(this.interval);
        this.value = 90;

        this.interval = setInterval(() =>
        {
            if (this.value === 0)
            {
                return;
            }
            this.value -= 1
        }, 1000)

        let lang = localStorage.getItem('language');
        if (lang == 'ar')
        {
            this.selectedLanguage = lang;
        }
        else
        {
            this.selectedLanguage = lang;
        }
    },
    methods: {
        trustDevice()
        {
            // clearInterval(this.interval);
            // this.value = 90;
            this.$emit('trustDevice');
        },
        close()
        {
            clearInterval(this.interval);
            this.value = 90;
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@core/preset/preset/auth.scss';

.card-action {
    margin-left: 9px;
    background: #E2F1FD;
    width: 29px;
    height: 27px;
    border-radius: 50%;


}

.v-dialog {
    box-shadow: none !important;
}

.switch-btn {
    margin-bottom: -21px;
}

.v-dialog-logout {
    min-width: 250px !important;
    max-width: 500px !important;
    margin: 0 auto;
    overflow: hidden !important;
}

.en-close {
    position: absolute;
    right: 10px;
    cursor: pointer;
}

.action-image {
    height: 35px;
    width: 35px;
    margin: 5px;
    // top: 6px;
}

.security {
    padding-left: 0px !important;
}
</style>
